// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__IWd6P","inputWrap":"styles_inputWrap__2d2Xa","input":"styles_input__PHtRp"};